import { Select } from '@oliasoft-open-source/react-ui-library';
import translations from 'client/internationalization/translation-map.json';
import { QueryLogicalOperator } from 'common/interfaces/query';
import { useTranslation } from 'react-i18next';

interface IQueryLogicalOperatorSelectProps {
  value: QueryLogicalOperator;
  onChange: (operator: QueryLogicalOperator) => void;
}

export const QueryLogicalOperatorSelect = ({ value, onChange }: IQueryLogicalOperatorSelectProps) => {
  const { t } = useTranslation();
  const options = [
    { label: t(translations.query_and), value: QueryLogicalOperator.And },
    { label: t(translations.query_or), value: QueryLogicalOperator.Or },
  ];

  return (
    <Select
      small
      width={72}
      value={value}
      options={options}
      onChange={(event) => onChange(event.target.value as QueryLogicalOperator)}
      searchable={false}
    />
  );
};
